import React from 'react';
import { Container, Row, Col, Modal } from 'reactstrap';

export class GallerySection extends React.Component {

  constructor(props) {
    super(props);

    this.openPictureModal = this.openPictureModal.bind(this);
    this.close = this.close.bind(this);

    this.state = {
      isOpen: false
    };
  }

  close(){
    this.setState({
      isOpen: false,
      picture: null
    })
  }

  openPictureModal(picture){
    this.setState({
      isOpen: true,
      picture
    })
  }

  render(){

    if(!Array.isArray(this.props.pictures))
      return null;

    const pictures = this.props.pictures.map( p => {
      return (
        <Col xs="4" sm="4" md="3" lg="2"
             className="image-container"
             key={p.ID}>
          <img width="100%"
               src={p.sizes.thumbnail}
               alt={p.title}
               onClick={() => this.openPictureModal(p)}/>
        </Col>
      );
    });

    return (
      <div>
        <Container className={"pictures-container"}>
          <Row>
            <Col xs={{ size: 12}} md={{ size: 10, offset: 1}} >
              <h2 className={"pb-5"}>More Pictures</h2>
              <div className={"pictures-grid"}>
                <Row>
                  { pictures }
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
        <Modal isOpen={this.state.isOpen}
               toggle={this.close}
               modalClassName={"image-full-modal"}
               backdropClassName={"image-full-backdrop"}
               contentClassName={"image-full-content"}
               onClick={this.close}>
          {
            Boolean(this.state.picture)
              ? <img width={this.state.picture.sizes['large-width']}
                     height={this.state.picture.sizes['large-height']}
                     src={this.state.picture.sizes.large}
                     alt={this.state.picture.title}/>
              : <span>Image missing</span>
          }
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/gallery/GallerySection.js